export default __webpack_public_path__ + "static/media/wb-4.fffdc52d.webp";